import React from 'react';

/**
 * Сроки хранения правила (Part 4, раздел 3.4).
 *
 * Поля всегда идут парой: правило валидации живёт в utils/violationRetention,
 * компонент только показывает её результат. Пустая пара означает «хранить по
 * умолчанию» — это нормальное состояние, а не незаполненная форма.
 */
const RetentionFields = ({ value, onChange, errors = {}, disabled = false, idPrefix = 'vio' }) => (
  <div className="vio-retention">
    <p className="vio-drawer-section-title">Сроки хранения</p>

    <div className="vio-field">
      <label className="vio-field-label" htmlFor={`${idPrefix}-retention-event`}>
        Хранить события, дней
      </label>
      <input
        id={`${idPrefix}-retention-event`}
        type="number"
        min="1"
        step="1"
        value={value.eventDays}
        disabled={disabled}
        onChange={(event) => onChange({ ...value, eventDays: event.target.value })}
      />
      {errors.eventDays && <p className="vio-field-error">{errors.eventDays}</p>}
    </div>

    <div className="vio-field">
      <label className="vio-field-label" htmlFor={`${idPrefix}-retention-evidence`}>
        Хранить фото, дней
      </label>
      <input
        id={`${idPrefix}-retention-evidence`}
        type="number"
        min="1"
        step="1"
        value={value.evidenceDays}
        disabled={disabled}
        onChange={(event) => onChange({ ...value, evidenceDays: event.target.value })}
      />
      {errors.evidenceDays && <p className="vio-field-error">{errors.evidenceDays}</p>}
    </div>
  </div>
);

export default RetentionFields;
